import React, { Component, createRef } from 'react';
import GoogleMapsLink from './GoogleMapsLink/GoogleMapsLink';
import Filters from './Filters/Filters';
import Modal from '../modal/Modal';
import Accordion from '../Accordion/Accordion';
import * as settings from './settings';
import axios from 'axios';

export default class Map extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mapLocations: this.props.coordinates,
            isModalActive: false,
            modalMarkers: [],
            modalContent: null,
        };

        this.googleMapRef = createRef();
        this.loaderRef = createRef();

        // Base map component functions
        this.addGoogleScript = this.addGoogleScript.bind(this);
        this.addClustererScript = this.addClustererScript.bind(this);
        this.createMap = this.createMap.bind(this);
        this.fetchMapPoints = this.fetchMapPoints.bind(this);
        this.createMarkers = this.createMarkers.bind(this);
        this.addClusterer = this.addClusterer.bind(this);
        this.updateClusterer = this.updateClusterer.bind(this);
        this.getMarkerByPointId = this.getMarkerByPointId.bind(this);
        // Map filters
        this.setMarkerVisibility = this.setMarkerVisibility.bind(this);
        this.focusMarker = this.focusMarker.bind(this);
        // Map modal
        this.handleMarkerClick = this.handleMarkerClick.bind(this);
        this.handleClusterClick = this.handleClusterClick.bind(this);
        this.getMarkerInfo = this.getMarkerInfo.bind(this);
        this.setModalActive = this.setModalActive.bind(this);
        this.getBusinessCard = this.getBusinessCard.bind(this);
        this.createModalContent = this.createModalContent.bind(this);
    }

    componentDidMount() {
        this.addGoogleScript();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.modalMarkers !== this.state.modalMarkers) {
            this.createModalContent();
        }
    }

    fetchMapPoints() {
        let url = "",
            params = {};

        if (this.props.guid) {
            url = settings.locationsAPIurls.single;
            params = {
                guid: this.props.guid,
            };
        } else {
            url = settings.locationsAPIurls.all;
        }

        axios
            .get(url, {
                params: params,
            })
            .then(response => {
                const locations = response.data;

                locations.map(location => {
                    location.typeVariable = location.Type;
                    location.Type = settings.officeNameMap[location.Type];
                });

                this.setState({
                    mapLocations: locations,
                });
                this.createMap();
            });
    }

    /* Add Google Maps API script and wait for it to load */
    addGoogleScript() {
        let script = document.querySelector(`[src*='${settings.googleMapsAPIurl}']`);

        if (!script) {
            script = document.createElement("script");
            script.setAttribute("async", "");
            script.src = settings.googleMapsAPIurl;
            document.querySelector("body").appendChild(script);
        }

        script.addEventListener("load", this.props.coordinates ? this.createMap : this.fetchMapPoints);
    }

    addClustererScript() {
        let script = document.createElement("script");
        script.setAttribute("async", "");
        script.src = "/Static/src/global-scripts/markerclusterer_custom.min.js";
        script.addEventListener("load", () => {
            this.createMarkers();
            this.addClusterer();
        });

        document.querySelector("body").appendChild(script);
    }

    createMap() {
        let center = {};

        if (this.state.mapLocations.length == 1) {
            center.lat = this.state.mapLocations[0][settings.requestNamesMap.latitude];
            center.lng = this.state.mapLocations[0][settings.requestNamesMap.longitude];
        } else {
            center.lat = 0;
            center.lng = 0;
        }

        this.map = new google.maps.Map(this.googleMapRef.current, {
            center: center,
            zoom: settings.mapZoom[this.props.mapSize],
            mapTypeControl: false,
            disableDefaultUI: true,
            backgroundColor: "none",
            styles: settings.mapStyles,
            minZoom: settings.mapZoom.large,
            maxZoom: settings.mapZoom.small,
            isVisible: false,
            zoomControl: true,
            zoomTypeControlOptions: {
                position: google.maps.ControlPosition.CENTER_RIGHT
            }
        });

        this.addClustererScript();
    }

    createMarkers() {
        this.markers = [];

        this.state.mapLocations.map(point => {
            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(
                    point[settings.requestNamesMap.latitude],
                    point[settings.requestNamesMap.longitude]
                ),
                title: point[settings.requestNamesMap.name],
                icon: settings.markerStyles[settings.markerStyleTypeMap[point.typeVariable]],
                info: "",
                url: point[settings.requestNamesMap.url],
                type: point[settings.requestNamesMap.type],
                pointId: point[settings.requestNamesMap.id]
            });

            this.markers.push(marker);
        });

        if (this.props.mapSize === "large") {
            this.markers.map(marker => {
                google.maps.event.addListener(marker, "click", () => {
                    this.handleMarkerClick(marker);
                });
            });
        }
    }

    addClusterer() {
        this.markerCluster = new MarkerClusterer(this.map, this.markers, {
            ...settings.clusterOptions,
            batchSize: this.markers.length
        });

        google.maps.event.addListener(this.markerCluster, 'clusterclick', (cluster) => {
            this.handleClusterClick(cluster);
        });

        this.loaderRef.current.remove();
    }

    updateClusterer(filteredMarkers) {
        this.markerCluster.clearMarkers();
        this.markerCluster.addMarkers(filteredMarkers);
    }

    setMarkerVisibility(filteredLocations) {
        let filteredMarkers = [];

        if (filteredLocations.length === this.markers.length) {
            filteredMarkers = this.markers.filter(marker => {
                marker.setVisible(true);
                return marker;
            });
        } else {
            let location;
            filteredMarkers = this.markers.filter(marker => {
                location = filteredLocations.find(location => {
                    if (location[settings.requestNamesMap.id] === marker.pointId) {
                        marker.setVisible(true);
                        return location;
                    } else {
                        marker.setVisible(false);
                    }
                });

                if (location) {
                    return marker;
                }
            });
        }

        this.updateClusterer(filteredMarkers);
        this.map.setZoom(settings.mapZoom.large);
    }

    focusMarker(id) {
        let marker = this.getMarkerByPointId(id);
        if (marker) {
            this.map.setCenter(marker.getPosition());
        }
    }

    getMarkerInfo(marker) {
        axios.get(settings.locationsAPIurls.info, {
            params: {
                guid: marker.pointId,
            }
        })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
                console.log(error.config);
            })
            .then(response => {
                if (response && response.data) {
                    // save marker info in marker to reduce API calls
                    marker.info = response.data;

                    // Double check in case the call took a long time
                    if (this.state.modalMarkers.includes(marker)) {
                        this.createModalContent();
                    }
                }
            });
    }

    getMarkerByPointId(pointId) {
        return this.markers.find(marker => {
            if (marker.pointId === pointId) {
                return marker;
            }
        });
    }

    handleMarkerClick(marker) {
        this.setState({
            isModalActive: true,
            modalMarkers: [marker],
        }, this.focusMarker(marker.pointId));

        if (!marker.info) {
            this.getMarkerInfo(marker);
        }
    }

    handleClusterClick(cluster) {
        if (this.map.zoom === settings.mapZoom.small && cluster.markers_ && cluster.markers_.length) {
            this.setState({
                isModalActive: true,
                modalMarkers: cluster.markers_,
            }, this.map.setCenter(cluster.center_));

            cluster.markers_.forEach(marker => {
                if (!marker.info) {
                    this.getMarkerInfo(marker);
                }
            });
        }
    }

    setModalActive(value) {
        this.setState({
            isModalActive: value,
            modalContent: null
        });
    }

    createModalContent() {
        let modalContent;

        if (this.state.modalMarkers) {
            let modalMarkers = this.state.modalMarkers;

            if (modalMarkers.length === 1) {
                if (modalMarkers[0].info) {
                    modalContent = this.getBusinessCard(modalMarkers[0]);
                }
            } else {
                let accordionSections = [];

                {
                    this.state.modalMarkers.map(marker => {
                        let accordionTrigger = (
                            <React.Fragment>
                                <span className={"contact-location__icon contact-location__icon--"
                                    + settings.officeIconClassMap[marker.type]}></span>
                                <p className="accordion__description">
                                    {marker.type}
                                </p>
                                <h3 className="accordion__title">
                                    <a className="accordion__title-link" id="modal-button"
                                        href={marker.url}>
                                        {marker.title}
                                    </a>
                                </h3>
                            </React.Fragment>
                        );

                        let accordionContent = (
                            <React.Fragment>
                                {this.getBusinessCard(marker)}
                            </React.Fragment>
                        );

                        accordionSections.push({
                            index: marker.pointId,
                            accordionTrigger: accordionTrigger,
                            accordionContent: accordionContent,
                        });
                    })
                }

                modalContent = (
                    <React.Fragment>
                        <span className="icon--aggregated"></span>
                        <Accordion sections={accordionSections} />
                    </React.Fragment>
                );
            }
        }

        this.setState({
            modalContent: modalContent,
        });
    }

    getBusinessCard(marker) {
      let url = `${marker.url}`;
        return (
            <React.Fragment>
                <div dangerouslySetInnerHTML={{ __html: marker.info }} />
                <a className="listLink" id="modal-button"
                    href={url}>
                    Contact us about services in {marker.title}
                </a>
            </React.Fragment>
        );
    }

    render() {
        let googleMapsLink, filters, modal;

        if (this.state.mapLocations.length === 1) {
            const firstPoint = this.state.mapLocations[0];
            googleMapsLink = (
                <GoogleMapsLink
                    lat={firstPoint[settings.requestNamesMap.latitude]}
                    lng={firstPoint[settings.requestNamesMap.longitude]} />
            );
        } 
        else if (this.state.mapLocations.length > 1) {
            filters = (
                <Filters setMarkerVisibility={this.setMarkerVisibility}
                    focusMarker={this.focusMarker}
                    locations={this.state.mapLocations} />
            );

            modal = (
                <Modal isActive={this.state.isModalActive}
                    modalContent={this.state.modalContent}
                    setModalActive={this.setModalActive}
                    hasLargeContent={this.state.modalMarkers.length > 1} />
            );
        }

        return (
            <div className="map-component">
                {filters}
                <div className={"map-component__map map-component__map--" + this.props.mapSize}
                    ref={this.googleMapRef}>
                </div>
                <div className="loader--full-screen"
                    ref={this.loaderRef}>
                    <div className="loader__icon" />
                </div>
                {modal}
                {googleMapsLink}
            </div>
        );
    }
}